<template>
    <div>
      <div class="d-flex  justify-content-between align-items-center mb-4">
        <div>
          <h5 class="card-title">{{stage.name}}</h5>
          <p class="card-text text-muted">
            {{ $t('Start at:') }} {{ dayjs(stage.start_at).format('LLLL') }}
            <br>{{ $t('End at:') }} {{ dayjs(stage.end_at).format('LLLL') }}
          </p>
        </div>
        <AddSlot
          :zone="zone"
          :stage="stage"
          v-on:add-slot="addSlot($event)"
        >
        </AddSlot>
      </div>
      <div v-if="stage.booking_slots.length ===0">
        <Alert variant="danger">
          {{ $t('No slots configured for this stage.') }}
        </Alert>
      </div>
      <BookingSlot v-for="bookingSlot in stage.booking_slots"
                      :slot-resource-url="slotResourceUrl"
                      :key="bookingSlot.id"
                      :booking-slot="bookingSlot"
                      :stage="stage"
                      :zone="zone"
                      @change="updateSlot"
                      @delete="deleteSlot"
      >
      </BookingSlot>
    </div>
</template>

<script>
    import BookingSlot from './BookingSlot.vue'
    import AddSlot from './AddSlot.vue'
    import dayjs from "dayjs";
    import Alert from "@/components/ui/Alert.vue";
    import { toast } from "vue-sonner";
    export default {
      name: "stage",
      computed: {
        dayjs() {
          return dayjs
        },
      },
        components: {
          Alert,
            AddSlot,
            BookingSlot
        },
        props: {
            stage: {
                type: Object,
            },
            zone: {
                default: 'UTC'
            },
            slotResourceUrl: {
                type: String,
                required: true,
            },
        },
        methods: {
            addSlot(slot) {
                var vm = this;
                axios.post(vm.slotResourceUrl, slot, {
                  headers: {
                    'Content-Type': 'application/json'
                  }
                })
                    .then(function (response) {
                        // vm.slots.push(response.data);
                        vm.$emit('slot-added', response.data.data);
                    })
                    .catch(function (error) {
                      console.log(error)
                      error.response?.data?.message ? Object.values(error.response.data.message).forEach(e => {
                        console.log(e)
                        toast.error(e[0])
                      }) : toast.error(error.message)
                    })
            },
            deleteSlot(slotId) {
              console.log('delete Slot', slotId);
              let slots = [
                ...this.stage.booking_slots.filter(s => s.id !== slotId),
              ];
              this.$emit('slots-updated', slots);
            },
            updateSlot(slot) {
              console.log('updateSlot', slot);
              let slots = [
                ...this.stage.booking_slots.filter(s => s.id !== slot.id),
                slot
              ];
              slots.sort((a, b) => {
                const dateA = dayjs(a.start_at);
                const dateB = dayjs(b.start_at);
                return dateA - dateB;
              });
              console.log('slots', slots);
              this.$emit('slots-updated', slots);
            }
        },
        mounted() {
        }

    }
</script>

<style lang="scss" scoped>

</style>
